import React from "react";

const DealerOutlet = () => {
  return <div>DealerOutlet</div>;
};

export default DealerOutlet;
